import {
  Button,
  JoonUIColor,
  Modal,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import ThoughtfulModal, { useThoughtfulModalStore } from "./ThoughtfulModal"
import useMobile from "../../../hooks/useMobile"
import { createReferralGiftCard } from "../../../networking/users/api"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../../util/analytics"
import { shareGuestPass } from "../../../util/util"

interface ReferralModalStoreProps {
  isOpen: boolean
  onOpen: (location: "me_tab_icon" | "me_tab_card") => void
  onClose: () => void
}

export const useReferralModalStore = create<ReferralModalStoreProps>((set) => ({
  isOpen: false,
  onOpen: (location: "me_tab_icon" | "me_tab_card") => {
    trackAnalyticEvent(ANALYTIC_EVENTS.OPEN_REFERRALS_PAGE, { location })
    set({ isOpen: true })
  },
  onClose: () => set({ isOpen: false }),
}))

const ReferralModal = () => {
  const [isLoading, setIsLoading] = useState(false)
  const { isOpen, onClose } = useReferralModalStore()
  const { onOpen: onOpenThoughtfulModal } = useThoughtfulModalStore()
  const isMobile = useMobile()
  const { t } = useTranslation()

  const onShareGuestPass = async () => {
    setIsLoading(true)
    const referralGiftCard = await createReferralGiftCard()
    setIsLoading(false)
    if (!referralGiftCard || !referralGiftCard.uuid) return
    await shareGuestPass(referralGiftCard, onOpenThoughtfulModal)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} animate mobileFull>
      <div
        className="flex flex-col gap-4 p-6"
        style={{
          background:
            "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(224,242,255,1) 100%)",
          width: isMobile ? "100vw" : "450px",
          height: "100%",
          overflowY: "auto",
        }}
      >
        <div className="w-[80%] mx-auto mb-4">
          <Typography variant="h3" textAlign="center">
            {t("REFERRAL_MODAL_TITLE")}
          </Typography>
        </div>

        <img
          src={"/images/referral_gift_card.png"}
          alt="Referral Gift Card"
          className="w-[80%] mx-auto"
        />
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col items-center w-[80%]">
            <Typography variant="bodySmall" textAlign="center">
              {t("REFERRAL_MODAL_WITH")}
            </Typography>
            <Typography variant="h2" textAlign="center">
              {t("REFERRAL_MODAL_PASS_NAME")}
            </Typography>
          </div>
          <Typography variant="body" textAlign="center">
            {t("REFERRAL_MODAL_DESC")}
          </Typography>
          <div className="w-full flex flex-col gap-2 items-center">
            <Button
              text={t("REFERRAL_MODAL_SHARE")}
              onClick={onShareGuestPass}
              isLoading={isLoading}
              fullWidth
            />
            <TextButton onClick={onClose} style={{ width: "fit-content" }}>
              <Typography
                variant="bodyBold"
                color={JoonUIColor.text.primaryAccent}
              >
                {t("REFERRAL_MODAL_MAYBE_LATER")}
              </Typography>
            </TextButton>
          </div>
        </div>
      </div>
      <ThoughtfulModal onShareGuestPass={onShareGuestPass} />
    </Modal>
  )
}

export default ReferralModal
